<template>
  <div>
    <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      :dark="dark"
      :expand-on-hover="!isSidebarFixed"
      :mini-variant="isSidebarFixed"
      :right="$vuetify.rtl"
      :mini-variant-width="60"
      v-bind="$attrs"
      :hide-overlay="false"
      @mouseover.native="isHovered = true"
      @mouseout.native="isHovered = false"
      :class="{ 'drawer-expanded': !isSidebarFixed && isHovered }"
      style="max-height: max-content;"
    >
      <v-list-item two-line to="/" style="min-height: 50px; max-height: 75px">
        <v-list-item-content class="py-0 my-0" style="display: flex; justify-content: center; align-items: center;">
          <span
            class="logo-mini"
            :class="{ 'ml-30': !isSidebarFixed && !isHovered }"
          >
            <img src="/static/logo2.png" width="45" alt="Doc.ECM" />
          </span>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mb-0" />

      <v-list expand nav>
        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />
        <template>
          <v-list-item
            v-for="(item, i) in userMenu"
            :key="i"
          >
            <template v-if="item.children">
              <v-list-group
                :value="isLevel1Selected(i)"
                @click="onItemClick(item.id)"
                append-icon="mdi-menu-down"
                :prepend-icon="item.icon"
                :sub-group="subGroup"
                :v-model="expanded"
                :color="
                  barColor !==
                  'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'
                    ? 'white'
                    : 'grey darken-1'
                "
                style="width: 100%;"
              >
                <template v-slot:activator>
                  <v-list-item-content style="width: 140px">
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-for="(child, j) in item.children">
                  <v-list-group
                    v-if="child.singleOption === false || child.singleOption"
                    :value="isLevel2Selected(i, j)"
                    :key="`sub-group-${j}`"
                    :prepend-icon="child.icon"
                    sub-group
                    @click="navigateTo(child)"
                    :color="
                      barColor !==
                      'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'
                        ? 'white'
                        : 'grey darken-1'
                    "
                  >
                    <template v-slot:activator>
                      <v-list-item-content style="width: 140px">
                        <v-list-item-title
                          v-text="child.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-icon small v-if="!child.singleOption"
                        >mdi-menu-down</v-icon
                      >
                    </template>

                    <v-list-item
                      v-for="(grandchild, k) in child.children"
                      @click="navigateTo(child, grandchild)"
                      :key="`item-${k}`"
                      :item="child"
                      :class="{
                        'grand-child--active': isSelected(grandchild),
                      }"
                    >
                      <v-list-item-icon
                        class="v-list-item__icon--text"
                        v-text="'-'"
                      />
                      <v-list-item-title
                        v-text="grandchild.title"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list-group>

                  <v-list-item
                    v-if="!child.singleOption && !child.children"
                    :key="'child-' + j"
                    link
                    @click="onItemClick(child)"
                    :item="child"
                    :class="{ 'grand-child--active': isSelected(child) }"
                  >
                    <v-list-item-icon
                      class="v-list-item__icon--text"
                      v-text="'-'"
                    />
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="child.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>

            <v-list-item v-else :key="'item-' + i" @click="onItemClick(item)" style="width: 100%">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </template>

        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />
      </v-list>

      <template v-slot:append>
        <div class="pb-4">
          <v-btn icon class="mx-2" @click.stop.prevent="toggleDrawer">
            <v-icon v-show="!isSidebarFixed">mdi-chevron-double-left</v-icon>
            <v-icon v-show="isSidebarFixed">mdi-chevron-double-right</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <AdvSearchModal :ref="advSearchModalKey" />
    <ParamSearchModal :ref="paramSearchModalKey" />
    <DocumentModal :ref="documentModalKey" />
  </div>
</template>

<script>
// Utilities
import Utils from '@/ecm/common/Utils';
import AdvSearchModal from '@/components/search/advSearch/AdvSearchModal';
import DocumentModal from '@/components/document/documentModal/DocumentModal';
import ParamSearchModal from '@/components/search/advSearch/ParamSearchModal.vue';
import SearchType from '@/ecm/variables/SearchType';

export default {
    name: 'AppCoreDrawer',
    components: {
        AdvSearchModal,
        DocumentModal,
        ParamSearchModal,
    },
    props: {},
    data: () => ({
        advSearchModalKey: 'advSearchModal',
        paramSearchModalKey: 'paramSearchModal',
        documentModalKey: 'documentModal',
        drawerWidth: null,
        selectedItemsLevel1: {},
        selectedItemsLevel2: {},
        subGroup: null,
        expanded: null,
        selectedGrandchild: null,
        selectedChild: null,
        isSidebarFixed: false,
        isHovered: false
    }),
    computed: {
        barColor() {
            return this.$store.getters['theme/barColor'];
        },
        dark() {
            return !this.$store.getters['theme/dark'];
        },
        advSearchModalInstance() {
            return this.$refs[this.advSearchModalKey];
        },
        paramSearchModalInstance() {
            return this.$refs[this.paramSearchModalKey];
        },
        documentModalInstance() {
            return this.$refs[this.documentModalKey];
        },
        drawer: {
            get() {
                return this.$store.getters['theme/drawer'];
            },
            set(val) {
                this.$store.dispatch('theme/setDrawer', val);
            },
        },
        userMenu: {
            get() {
                const menu = [
                    {
                        icon: 'mdi-view-dashboard',
                        title: this.$t('Dashboard'),
                        to: this.$store.getters['account/currentRole'] == 0 ? '/admin/dashboard' : '/dashboard'
                    }
                ];

                // User Menu Options
                const userMenu = this.$store.getters['account/userMenu'];
                if (!Utils.object.isEmpty(userMenu)) {
                    if (userMenu.CanSearch) {
                        menu.push({
                            icon: 'mdi-magnify-plus',
                            title: this.$t('AdvancedSearch'),
                            id: 'advSearch',
                        });

                        // User Saved Searches
                        const userSavedSearches =
                            this.$store.getters['account/userSavedSearches'];
                        if (userSavedSearches != null && userSavedSearches.length > 0) {
                            const userSearchesMenu = {
                                group: '/userSearches',
                                icon: 'mdi-folder-search',
                                title: this.$t('SavedSearches'),
                                children: [],
                            };
                            for (let index = 0; index < userSavedSearches.length; index++) {
                                const opt = userSavedSearches[index];
                                userSearchesMenu.children.push({
                                    title: opt.FilterName,
                                    to: opt.IsParameterizable
                                        ? ''
                                        : `search/${SearchType.UserSearch}/${opt.Id}`,
                                    id: `paramSearch-${opt.Id}`,
                                });
                            }
                            menu.push(userSearchesMenu);
                        }
                    }

                    if (userMenu.CanCreateDocuments) {
                        menu.push({
                            icon: 'mdi-file-plus',
                            title: this.$t('NewDocument'),
                            id: 'newDocument',
                        });
                    }

                    if (userMenu.CanViewAI) {
                        menu.push({
                            icon: 'mdi-format-list-checks',
                            title: this.$t('AutoimportTitle'),
                            to: '/aiRecognition/documents'
                        });
                    }

                    if (userMenu.MenuOptionGroups.length > 0) {
                        const admMenu = {
                            group: '/administration',
                            icon: 'mdi-view-comfy',
                            title: this.$t('Administration'),
                            children: [],
                        };

                        for (
                            let groupCounter = 0;
                            groupCounter < userMenu.MenuOptionGroups.length;
                            groupCounter++
                        ) {
                            const optGroup = userMenu.MenuOptionGroups[groupCounter];
                            let optGroupMenu;

                            if (!optGroup.SingleOption) {
                                optGroupMenu = {
                                    group: optGroup.Id,
                                    icon: optGroup.Icon,
                                    title: optGroup.Name,
                                    singleOption: optGroup.SingleOption,
                                    children: [],
                                };
                                for (
                                    let childrenCounter = 0;
                                    childrenCounter < optGroup.MenuOptions.length;
                                    childrenCounter++
                                ) {
                                    const opt = optGroup.MenuOptions[childrenCounter];
                                    optGroupMenu.children.push({
                                        title: opt.Name,
                                        to: opt.Url,
                                    });
                                }
                            } else {
                                optGroupMenu = {
                                    group: optGroup.Id,
                                    icon: optGroup.Icon,
                                    title: optGroup.Name,
                                    singleOption: optGroup.SingleOption,
                                    to: optGroup.MenuOptions[0].Url,
                                };
                            }
                            admMenu.children.push(optGroupMenu);
                        }
                        menu.push(admMenu);
                    }
                }
                return menu;
            },
        },
    },
    watch: {
        '$vuetify.breakpoint.mobile': {
            immediate: true,
            handler(val) {
                this.$store.dispatch('theme/setDrawer', !val);
            },
        },
    },
    methods: {
        isSelected(item) {
            if (this.selectedGrandchild && item === this.selectedGrandchild) {
                return true;
            } else if (this.selectedChild && item === this.selectedChild) {
                return true;
            }
        },
        navigateTo(child, selectedChild) {
            try {
                const route = selectedChild && selectedChild.to ? selectedChild.to : child.to;

                if (!route) { // Handle three levels
                    return;
                }

                const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
                this.$router.push({ path: normalizedRoute });
                this.selectedGrandchild = selectedChild;
                this.selectedChild = child;
            } catch (error) {
                console.error('Error during navigation:', error);
            }
        },
        isLevel1Selected(i) {
            return this.selectedItemsLevel1[i];
        },
        isLevel2Selected(i, j) {
            return this.selectedItemsLevel2[i] && this.selectedItemsLevel2[i][j];
        },
        toggleDrawer() {
            this.isSidebarFixed = !this.isSidebarFixed;
        },
        onItemClick(child) {
            if (!child) { // Handle three levels
                return;
            }

            const itemID = child.id;
            if (itemID) {
                if (itemID.includes('advSearch')) {
                    this.advSearchModalInstance.show();
                } else if (itemID.includes('newDocument')) {
                    this.documentModalInstance.new();
                } else if (itemID.includes('paramSearch')) {
                    var userSearchID = parseInt(
                        itemID.replace('paramSearch-', '').trim()
                    );
                    var userSearch = this.$store.getters[
                        'account/userSavedSearches'
                    ].find((x) => x.Id == userSearchID);
                    if (userSearch && userSearch.IsParameterizable) {
                        this.paramSearchModalInstance.edit(userSearch);
                    } else {
                        this.navigateTo(child);
                    }
                }
            } else {
                this.navigateTo(child);
            }
        },
    },
};
</script>
<style>
.v-navigation-drawer {
  z-index: 10 !important;
}

.v-list-group--sub-group.v-list-group--active
  .v-list-item__icon.v-list-group__header__prepend-icon
  .v-icon {
  transform: none !important;
}

.grand-child--active {
  background-color: #00acc1 !important;
}

.drawer-expanded{
  width: 21vw !important;
}

.ml-30 {
  margin-left: 30px !important;
}
</style>
